import { Activities } from "src/modules/activity-log/activity";
import environment from "src/utils/environment";

export default function getColors({ isDarkMode, activity, mode, error }) {
  let bg =
    isDarkMode &&
    (activity === Activities.SLEEPING ||
      (activity === Activities.MOTION && environment.isBarkio)) &&
    mode === "audio"
      ? "white20"
      : "black8";
  let color =
    !isDarkMode &&
    (activity === Activities.SLEEPING ||
      (activity === Activities.MOTION && environment.isBarkio)) &&
    mode === "audio"
      ? "black54"
      : "white";

  if (error) {
    bg = "black8";
    color = "white";
  }

  return { bg, color };
}
